/** Chart link stroke width bounds (px). */
export var COMMUNICATION_CHART_LINK_LINE_WIDTH_MIN_PX = 1;
export var COMMUNICATION_CHART_LINK_LINE_WIDTH_MAX_PX = 6;
/** Synthetic chart node id for aggregated external (non-org) DM partners. */
export var COMMUNICATION_CHART_EXTERNAL_NODE_ID = 0;
export var COMMUNICATION_CHART_EXTERNAL_NODE_NAME = 'External';
/** Inspector where-row key for users without an org unit assignment. */
export var COMMUNICATION_CHART_UNASSIGNED_ORG_UNIT_KEY = 'unassignedOrgUnit';
/** Synthetic chart node for aggregated cross-team communication (team user view). */
export var COMMUNICATION_CHART_CROSS_TEAM_AGGREGATE_NODE_ID = -1;
export var COMMUNICATION_CHART_CROSS_TEAM_AGGREGATE_NODE_NAME = 'Cross-Team';
/** Synthetic chart node id for collapsed weak DM partners. */
export var COMMUNICATION_CHART_OTHER_NODE_ID = -2;
export var COMMUNICATION_CHART_OTHER_NODE_NAME = 'Other';
/** Synthetic per-team node for pure intra-team meetings (org ALL teams view). */
export var COMMUNICATION_CHART_INTERNAL_NODE_NAME = 'Team-only';
/** Base offset for per-team internal meet node ids (see helpers below). */
export var COMMUNICATION_CHART_INTERNAL_NODE_ID_OFFSET = -10000;
export var getCommunicationChartInternalNodeIdForTeam = function (teamId) { return COMMUNICATION_CHART_INTERNAL_NODE_ID_OFFSET - teamId; };
/** Synthetic per-team node for cross-team internal space/group chat (org ALL teams view). */
export var COMMUNICATION_CHART_CROSS_TEAM_SPACE_CHAT_NODE_NAME = 'Cross-team';
/** Base offset for per-team cross-team space chat node ids (see helpers below). */
export var COMMUNICATION_CHART_CROSS_TEAM_SPACE_CHAT_NODE_ID_OFFSET = -20000;
export var getCommunicationChartCrossTeamSpaceNodeIdForTeam = function (teamId) { return COMMUNICATION_CHART_CROSS_TEAM_SPACE_CHAT_NODE_ID_OFFSET - teamId; };
/** Synthetic per-team node for space/group chat with external members (org ALL teams view). */
export var COMMUNICATION_CHART_EXTERNAL_SPACE_CHAT_NODE_NAME = 'External';
/** Base offset for per-team external space chat node ids (see helpers below). */
export var COMMUNICATION_CHART_EXTERNAL_SPACE_CHAT_NODE_ID_OFFSET = -30000;
export var getCommunicationChartExternalSpaceNodeIdForTeam = function (teamId) { return COMMUNICATION_CHART_EXTERNAL_SPACE_CHAT_NODE_ID_OFFSET - teamId; };
export var isCommunicationChartExternalSpaceNodeId = function (nodeId) {
    return nodeId <= COMMUNICATION_CHART_EXTERNAL_SPACE_CHAT_NODE_ID_OFFSET - 1;
};
export var getCommunicationChartTeamIdForExternalSpaceNode = function (nodeId) {
    if (!isCommunicationChartExternalSpaceNodeId(nodeId)) {
        return null;
    }
    return -(nodeId - COMMUNICATION_CHART_EXTERNAL_SPACE_CHAT_NODE_ID_OFFSET);
};
export var isCommunicationChartCrossTeamSpaceNodeId = function (nodeId) {
    return nodeId <= COMMUNICATION_CHART_CROSS_TEAM_SPACE_CHAT_NODE_ID_OFFSET - 1 &&
        nodeId > COMMUNICATION_CHART_EXTERNAL_SPACE_CHAT_NODE_ID_OFFSET - 1;
};
export var getCommunicationChartTeamIdForCrossTeamSpaceNode = function (nodeId) {
    if (!isCommunicationChartCrossTeamSpaceNodeId(nodeId)) {
        return null;
    }
    return -(nodeId - COMMUNICATION_CHART_CROSS_TEAM_SPACE_CHAT_NODE_ID_OFFSET);
};
export var getCommunicationChartTeamIdForInternalNode = function (nodeId) {
    if (!isCommunicationChartInternalMeetNodeId(nodeId)) {
        return null;
    }
    return -(nodeId - COMMUNICATION_CHART_INTERNAL_NODE_ID_OFFSET);
};
export var isCommunicationChartInternalMeetNodeId = function (nodeId) {
    return nodeId <= COMMUNICATION_CHART_INTERNAL_NODE_ID_OFFSET - 1 &&
        nodeId > COMMUNICATION_CHART_CROSS_TEAM_SPACE_CHAT_NODE_ID_OFFSET - 1;
};
export var COMMUNICATION_CHART_LABEL_MAX_LENGTH = 20;
